// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.lds-roller,
.lds-roller div,
.lds-roller div:after {
  box-sizing: border-box;
}

.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}

.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7.2px;
  height: 7.2px;
  border-radius: 50%;
  background: currentColor;
  margin: -3.6px 0 0 -3.6px;
}

.lds-roller div:nth-child(1) { animation-delay: -0.036s; }
.lds-roller div:nth-child(1):after { top: 62.62742px; left: 62.62742px; }
.lds-roller div:nth-child(2) { animation-delay: -0.072s; }
.lds-roller div:nth-child(2):after { top: 67.71281px; left: 56px; }
.lds-roller div:nth-child(3) { animation-delay: -0.108s; }
.lds-roller div:nth-child(3):after { top: 70.90963px; left: 48.28221px; }
.lds-roller div:nth-child(4) { animation-delay: -0.144s; }
.lds-roller div:nth-child(4):after { top: 72px; left: 40px; }
.lds-roller div:nth-child(5) { animation-delay: -0.18s; }
.lds-roller div:nth-child(5):after { top: 70.90963px; left: 31.71779px; }
.lds-roller div:nth-child(6) { animation-delay: -0.216s; }
.lds-roller div:nth-child(6):after { top: 67.71281px; left: 24px; }
.lds-roller div:nth-child(7) { animation-delay: -0.252s; }
.lds-roller div:nth-child(7):after { top: 62.62742px; left: 17.37258px; }
.lds-roller div:nth-child(8) { animation-delay: -0.288s; }
.lds-roller div:nth-child(8):after { top: 56px; left: 12.28719px; }

@keyframes lds-roller {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/StandardLoader.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gEAAgE;EAChE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,+BAA+B,wBAAwB,EAAE;AACzD,qCAAqC,eAAe,EAAE,gBAAgB,EAAE;AACxE,+BAA+B,wBAAwB,EAAE;AACzD,qCAAqC,eAAe,EAAE,UAAU,EAAE;AAClE,+BAA+B,wBAAwB,EAAE;AACzD,qCAAqC,eAAe,EAAE,gBAAgB,EAAE;AACxE,+BAA+B,wBAAwB,EAAE;AACzD,qCAAqC,SAAS,EAAE,UAAU,EAAE;AAC5D,+BAA+B,uBAAuB,EAAE;AACxD,qCAAqC,eAAe,EAAE,gBAAgB,EAAE;AACxE,+BAA+B,wBAAwB,EAAE;AACzD,qCAAqC,eAAe,EAAE,UAAU,EAAE;AAClE,+BAA+B,wBAAwB,EAAE;AACzD,qCAAqC,eAAe,EAAE,gBAAgB,EAAE;AACxE,+BAA+B,wBAAwB,EAAE;AACzD,qCAAqC,SAAS,EAAE,gBAAgB,EAAE;;AAElE;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":[".loader-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(2px);\n}\n\n.lds-roller,\n.lds-roller div,\n.lds-roller div:after {\n  box-sizing: border-box;\n}\n\n.lds-roller {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n\n.lds-roller div {\n  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  transform-origin: 40px 40px;\n}\n\n.lds-roller div:after {\n  content: \" \";\n  display: block;\n  position: absolute;\n  width: 7.2px;\n  height: 7.2px;\n  border-radius: 50%;\n  background: currentColor;\n  margin: -3.6px 0 0 -3.6px;\n}\n\n.lds-roller div:nth-child(1) { animation-delay: -0.036s; }\n.lds-roller div:nth-child(1):after { top: 62.62742px; left: 62.62742px; }\n.lds-roller div:nth-child(2) { animation-delay: -0.072s; }\n.lds-roller div:nth-child(2):after { top: 67.71281px; left: 56px; }\n.lds-roller div:nth-child(3) { animation-delay: -0.108s; }\n.lds-roller div:nth-child(3):after { top: 70.90963px; left: 48.28221px; }\n.lds-roller div:nth-child(4) { animation-delay: -0.144s; }\n.lds-roller div:nth-child(4):after { top: 72px; left: 40px; }\n.lds-roller div:nth-child(5) { animation-delay: -0.18s; }\n.lds-roller div:nth-child(5):after { top: 70.90963px; left: 31.71779px; }\n.lds-roller div:nth-child(6) { animation-delay: -0.216s; }\n.lds-roller div:nth-child(6):after { top: 67.71281px; left: 24px; }\n.lds-roller div:nth-child(7) { animation-delay: -0.252s; }\n.lds-roller div:nth-child(7):after { top: 62.62742px; left: 17.37258px; }\n.lds-roller div:nth-child(8) { animation-delay: -0.288s; }\n.lds-roller div:nth-child(8):after { top: 56px; left: 12.28719px; }\n\n@keyframes lds-roller {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
